// extracted by mini-css-extract-plugin
export default {"textRecord":"NewRecord_textRecord__CDi9m"};